import { Record, Map } from "immutable";

const UserStateRecord = Record({
  users: Map(),
  loginUserId: null,
  loading: false,
  error: null
});

export default UserStateRecord;
